import { handleApi } from '../common';

const API_ENDPOINTS = {
	getAllRecommendedWatchlist:
		'/api/equity/api/eqm/wave/watchlist/fetch_recommendation_watchlists',
	updateWatchlist: '/api/equity/api/eqm/wave/watchlist/update_watchlist',
	deleteReorderWatchlist:
		'/api/equity/api/eqm/wave/watchlist/delete_reorder_watchlist',
	deleteScripFromWatchlists:
		'/api/equity/api/eqm/wave/watchlist/delete_item_multiple_watchlist',
	// v2 APIs
	createWatchlistV2: '/api/equity/api/eqm/wave/watchlist/create_watchlist/v2',
	updateWatchlistItemsV2:
		'/api/equity/api/eqm/wave/watchlist/add_update_items_watchlist/v2',
	getAllWatchlistsV2: (isGuestApiAllowed) =>
		`/api/equity/api/eqm/wave/watchlist/fetch_watchlists/v2?guest=${isGuestApiAllowed}`,
};

export const fetch_all_recommended_watchlist = async (Api) => {
	const response = await Api.get(API_ENDPOINTS.getAllRecommendedWatchlist);
	const result = handleApi(response);
	return result;
};

export const fetch_all_watchlists = async (Api, isGuestApiAllowed = false) => {
	const response = await Api.get(
		API_ENDPOINTS.getAllWatchlistsV2(isGuestApiAllowed),
	);
	const result = handleApi(response);
	return result;
};

export const create_watchlist = async (Api, payload, token = '') => {
	const response = await Api.post(
		API_ENDPOINTS.createWatchlistV2,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const delete_reorder_watchlist = async (Api, payload, token = '') => {
	const response = await Api.post(
		API_ENDPOINTS.deleteReorderWatchlist,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const update_watchlist_items = async (Api, payload, token = '') => {
	const response = await Api.post(
		API_ENDPOINTS.updateWatchlistItemsV2,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const update_watchlist = async (Api, payload, token = '') => {
	const response = await Api.post(
		API_ENDPOINTS.updateWatchlist,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const delete_scrips_from_watchlists = async (
	Api,
	payload,
	token = '',
) => {
	const response = await Api.post(
		API_ENDPOINTS.deleteScripFromWatchlists,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};
